module.exports = __webpack_public_path__ + "img/icono_cerrar.be7d9c0a.svg";